import { render, staticRenderFns } from "./AvSkeletonCard.vue?vue&type=template&id=5d9e84a1"
import script from "./AvSkeletonCard.vue?vue&type=script&lang=ts"
export * from "./AvSkeletonCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports